"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_cookie_1 = __importDefault(require("js-cookie"));
var jwt_decode_1 = __importDefault(require("jwt-decode"));
exports.default = {
    get idToken() {
        var rawToken = js_cookie_1.default.get("l360_" + process.env.NODE_ENV.toLowerCase() + "_id");
        if (rawToken) {
            return jwt_decode_1.default(rawToken);
        }
        else {
            return null;
        }
    }
};
//# sourceMappingURL=token_service.js.map